export type PhoneRules = {
  exact?: number;
  max?: number;
  min?: number;
};

export const hasPhoneFormatError = (input = "") => /\D/.test(input);

export const isPhoneInputValid = (
  input = "",
  phoneRules: PhoneRules = { min: 8, max: 10 }
) => {
  if (!input || hasPhoneFormatError(input)) {
    return false;
  }

  if (phoneRules.exact) {
    return input.length === phoneRules.exact;
  }

  const min = phoneRules.min || 8;
  const max = phoneRules.max || 10;
  return input.length >= min && input.length <= max;
};
